import { render, staticRenderFns } from "./CardRequestGenerated.vue?vue&type=template&id=58bb7cd6&"
import script from "./CardRequestGenerated.vue?vue&type=script&lang=js&"
export * from "./CardRequestGenerated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports